import { Circle } from '@mui/icons-material'
import React from 'react'

export default function PurchaseStatusIcon({ purchasedQty, balQty }) {
    return (
        <Circle style={{ color: purchasedQty == 0 ? 'gray' : balQty > 0 ? '#f1df09' : '#15d218', fontSize: '.9rem' }} />
    )
}
